export default {
    methods: {
        __groupBy(data, key) {
            return data.reduce(function(h, obj) {
                h[obj[key]] = (h[obj[key]] || []).concat(obj);
                return h;
            }, {});
        }
    }
};
